import { Controller } from "@hotwired/stimulus"

// Submits the controller's form when a child input fires its action — e.g. a
// <select> with data-action="change->auto-submit#submit". Used so the embed_code
// API-key picker reloads the page (server-rendered snippet + preview) on change.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
